import useGetContactCenterLogs from "hooks/useGetContactCenterLogs";
import { ContactCenterLogsParams } from "./interfaces/ContactCenterLogsParams";
import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import Table, { ColumnsType } from "antd/es/table";
import { IContactCenterLog } from "interfaces/contact-center-log";
import { getProperDate, sortDateDesc } from "utils/date";
import { Button, Skeleton, Tag } from "antd";
import { NoSpaceDivider, SectionTitle, SectionTitleActions, SectionTitleContainer } from "components/styles";
import ModalContactCenterLogModal from "./contac_center_logs_modal";
import { IContactCenterLogRequest } from "interfaces/IContactCenterLogRequest";

const TODAY_DATE = new Date();
const LAST_MONTH_DATE = new Date(new Date().setMonth(TODAY_DATE.getMonth() - 1));


const ContactCenterLogsTable = ({ searchParam, style}: { searchParam: ContactCenterLogsParams, style?: React.CSSProperties}) => {
    const [requestLogOpen, setRequestLogOpen] = useState(false);

    const [paginationModel, setPaginationModel] = useState({
        page: searchParam.page,
        pageSize: searchParam.size,
      });

    const [startDate, setStartDate] = useState<Dayjs>(dayjs(LAST_MONTH_DATE));
    const [endDate, setEndDate] = useState<Dayjs>(dayjs(TODAY_DATE));


    const { data, pageInfo, isLoading, isError, refresh: refreshLogs } = useGetContactCenterLogs(
        searchParam.cardholder_id,
        startDate.format('YYYY-MM-DDT00:00:00').toString(),
        endDate.format('YYYY-MM-DDT23:59:59').toString(),
        paginationModel.pageSize,
        paginationModel.page
    );


    const columns: ColumnsType<IContactCenterLog> = [
        {
          dataIndex: 'date',
          key: 'date',
          title: 'Fecha',
          defaultSortOrder: 'descend',
          sorter: (a, b) => sortDateDesc(b.date, a.date),
          render: (_, record) => {
            return getProperDate(record.date);
          },
        },
        { dataIndex: 'user', title: 'Usuario', key: 'user' },
        {
          dataIndex: 'reasons',
          title: 'Motivo',
          key: 'reasons',
          render: (_, record) => (
            <>
              {record.reasons.map((reason) => {
                return (
                  <Tag key={reason}>
                    {reason}
                  </Tag>
                );
              })}
            </>
          )
        },
        { dataIndex: 'observation', title: 'Obervación', key: 'observation' }
      ];


    const handlePaginationChange = (page: number, pageSize: number) => {
        setPaginationModel({ page: page - 1, pageSize });
    };

    const onContactCenterAdded = () => {
      refreshLogs()
    }


  return (
    <>
      {isLoading ? (
        <Skeleton />
      ) : (
        <>
        <SectionTitleContainer style={style}>
            <SectionTitle> Registros de contacto</SectionTitle>
            <SectionTitleActions>
                <Button type="link" onClick={() => setRequestLogOpen(true)}>
                    Agregar
                </Button>
            </SectionTitleActions>
        </SectionTitleContainer>
        <NoSpaceDivider />
        <Table style={{marginTop:'1em'}}
                dataSource={data || []}
                scroll={{ x: true }}
                // @ts-ignore
                columns={columns.filter((e) => Object.keys(e).length > 0)}
                loading={isLoading}
                pagination={{
                    total: pageInfo?.total,
                    showTotal: (total) => pageInfo?.total !== undefined ? `Total: ${total}` : ``,
                    defaultPageSize: paginationModel.pageSize,
                    defaultCurrent: 1,
                    onChange: handlePaginationChange,
                    pageSizeOptions: ['10', '25', '50', '100'],
                    showSizeChanger: true,
                }}
          />

        <ModalContactCenterLogModal
          open={requestLogOpen}
          setRequestLogOpen={setRequestLogOpen}
          onCancel={() => setRequestLogOpen(false)}
          cardholder={searchParam.cardholder_id}
          onContactCenterAdded={onContactCenterAdded}
        />
        </>
      )}

    </>
  )
}

export default ContactCenterLogsTable;
